import { SbBlokData } from '@storyblok/react/rsc'

export default function FallbackComponent({ blok }: { blok: SbBlokData }) {
  // Log the error for developers but don't show anything to users
  if (process.env.NODE_ENV === 'development') {
    console.warn(`Missing Storyblok component: "${blok.component}"`, blok)
  }

  // In production, render nothing - component just disappears silently
  return null
}
